import { useCallback, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useBulkUpdateSubscriptionsMutation } from '../../../__generated__/chirp/com/hubspot/esp/sync/rpc/FormSubscriptionsRpc.hooks';
import { useGetSubscriptionsQuery } from '../../../__generated__/chirp/com/hubspot/esp/sync/rpc/FormSubscriptionsRpc.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ESPSettingsDialog({
  crmObject,
  onClose
}) {
  const [subscriptionState, setSubscriptionState] = useState([]);
  const formGuid = getPropertyValue(crmObject, 'hs_form_id') || '';
  const {
    data,
    loading
  } = useGetSubscriptionsQuery({
    variables: {
      formGuid
    },
    fetchPolicy: 'no-cache'
  });
  const [updateSubscriptions] = useBulkUpdateSubscriptionsMutation();
  const subscriptions = useMemo(() => {
    var _data$subscriptions;
    return (_data$subscriptions = data === null || data === void 0 ? void 0 : data.subscriptions) !== null && _data$subscriptions !== void 0 ? _data$subscriptions : [];
  }, [data === null || data === void 0 ? void 0 : data.subscriptions]);
  const isDisabled = useMemo(() => {
    var _subscriptions$length;
    return loading || ((_subscriptions$length = subscriptions.length) !== null && _subscriptions$length !== void 0 ? _subscriptions$length : 0) === 0;
  }, [subscriptions.length, loading]);
  const handleSave = useCallback(() => {
    if (subscriptionState.length === 0) {
      onClose();
    } else {
      updateSubscriptions({
        variables: {
          subscriptions: subscriptionState
        }
      }).then(onClose).catch(() => {});
    }
  }, [onClose, subscriptionState, updateSubscriptions]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "esp-settings-dialog",
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.header"
        })
      })
    }), loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 80,
      layout: "centered"
    }) : /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormControl, {
        label: subscriptions.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.body.noLists"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.body.lists"
        }),
        children: /*#__PURE__*/_jsx(ToggleGroup, {
          name: "subscriptions",
          children: subscriptions.map(({
            espListId,
            name,
            syncEnabled
          }) => /*#__PURE__*/_jsx(Checkbox, {
            defaultChecked: syncEnabled,
            onChange: event => {
              setSubscriptionState(prevState => {
                // If no previous state, use the current subscriptions as base
                const currentState = prevState.length > 0 ? prevState : subscriptions;
                return currentState.map(sub => {
                  if (sub.espListId === espListId) {
                    return Object.assign({}, sub, {
                      syncEnabled: event.target.checked
                    });
                  }
                  return sub;
                });
              });
            },
            children: name
          }, espListId))
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: isDisabled,
        onClick: handleSave,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.save"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "clone-form-cancel-button",
        use: "secondary",
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.cancel"
        })
      })]
    })]
  });
}